module.exports = __webpack_public_path__ + "media/images/logo-background2-373d5732d966d96da2ca5d0ba738597a.png";